import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router.js'
import './style.css'
import { initSentry } from './sentry.js'

const app = createApp(App)
app.use(createPinia())
app.use(router)
initSentry(app, router)
app.mount('#app')
